import { BaseChart } from '@components/common';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { StyledCard } from './stlyed';

import moment from 'moment';
import useFetchEventsByAlert from './hooks/useFetchEventsByAlert';
import { isEmpty } from 'lodash';
import { Skeleton, Tooltip } from 'antd';
import { buildEventHeatMap } from './hooks/utils';
import { InfoCircleOutlined } from '@ant-design/icons';
import { HeatMapColors } from '../styled';
import { formatTimeInfo } from '../AIAlert/hooks/utils';

const buildOption = (chartData) => {
  return {
    tooltip: {
      formatter: function ({ data }) {
        return `${data[0]}: ${data[1]}`;
      },
    },
    visualMap: {
      // min: 0,
      // max: 100,
      // type: 'piecewise',
      orient: 'horizontal',
      left: 'center',
      bottom: 10,
      min: 0,
      max: 100,
      calculable: true,
      color: HeatMapColors,
    },
    calendar: {
      top: 25,
      left: 30,
      right: 10,
      // cellSize: 30,
      range: [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      yearLabel: { show: false },
      orient: 'vertical',
      dayLabel: {
        firstDay: 1,
        nameMap: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      },
    },
    series: {
      type: 'heatmap',
      coordinateSystem: 'calendar',
      data: chartData,
      label: {
        show: true,
        formatter: ({ data }) => data[1],
      },
    },
  };
};

function HeatMap({ alertId }) {
  const [instance, setInstance] = useState(null);
  const chartInstanceRefCb: any = useCallback((instance) => {
    setInstance(instance);
  }, []);

  const { isLoading, data: alert, interval }: any = useFetchEventsByAlert({ alertId });

  const chartData = useMemo(() => {
    if (alert) {
      const chartData = buildEventHeatMap(alert);
      return chartData;
    }
  }, [alert]);

  useEffect(() => {
    if (instance) {
      const option = buildOption(chartData);
      instance.setOption(option);
    }
  }, [instance, chartData]);

  if (isLoading || isEmpty(alert)) {
    return (
      <StyledCard variant="borderless">
        <Skeleton />
      </StyledCard>
    );
  }

  return (
    <StyledCard
      title={<h4>Event Heat Map (last 30 days)</h4>}
      extra={
        <Tooltip title={`${formatTimeInfo(interval)}. Lists up to a maximum of 1000 events`}>
          <InfoCircleOutlined />
        </Tooltip>
      }
    >
      <BaseChart
        key="alert-heat-map"
        chartId="alert-heat-map"
        chartInstanceRefCb={chartInstanceRefCb}
        style={{ height: '100%', minHeight: 220 }}
      />
    </StyledCard>
  );
}

export default HeatMap;
